/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GlobalCitiesListResponse } from '../models';
// @ts-ignore
import { GlobalCityResponse } from '../models';
/**
 * GlobalCitiesApi - axios parameter creator
 * @export
 */
export const GlobalCitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get lobal cities by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCitiesControllerGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('globalCitiesControllerGet', 'id', id)
            const localVarPath = `/v2/core/global-cities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all global cities
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCitiesControllerList: async (search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/core/global-cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalCitiesApi - functional programming interface
 * @export
 */
export const GlobalCitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalCitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get lobal cities by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalCitiesControllerGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalCityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalCitiesControllerGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalCitiesApi.globalCitiesControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all global cities
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalCitiesControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalCitiesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalCitiesControllerList(search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalCitiesApi.globalCitiesControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalCitiesApi - factory interface
 * @export
 */
export const GlobalCitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalCitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get lobal cities by Id
         * @param {GlobalCitiesApiGlobalCitiesControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCitiesControllerGet(requestParameters: GlobalCitiesApiGlobalCitiesControllerGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalCityResponse> {
            return localVarFp.globalCitiesControllerGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all global cities
         * @param {GlobalCitiesApiGlobalCitiesControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCitiesControllerList(requestParameters: GlobalCitiesApiGlobalCitiesControllerListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GlobalCitiesListResponse> {
            return localVarFp.globalCitiesControllerList(requestParameters.search, requestParameters.limit, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for globalCitiesControllerGet operation in GlobalCitiesApi.
 * @export
 * @interface GlobalCitiesApiGlobalCitiesControllerGetRequest
 */
export interface GlobalCitiesApiGlobalCitiesControllerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GlobalCitiesApiGlobalCitiesControllerGet
     */
    readonly id: string
}

/**
 * Request parameters for globalCitiesControllerList operation in GlobalCitiesApi.
 * @export
 * @interface GlobalCitiesApiGlobalCitiesControllerListRequest
 */
export interface GlobalCitiesApiGlobalCitiesControllerListRequest {
    /**
     * 
     * @type {string}
     * @memberof GlobalCitiesApiGlobalCitiesControllerList
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof GlobalCitiesApiGlobalCitiesControllerList
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof GlobalCitiesApiGlobalCitiesControllerList
     */
    readonly skip?: number
}

/**
 * GlobalCitiesApi - object-oriented interface
 * @export
 * @class GlobalCitiesApi
 * @extends {BaseAPI}
 */
export class GlobalCitiesApi extends BaseAPI {
    /**
     * 
     * @summary Get lobal cities by Id
     * @param {GlobalCitiesApiGlobalCitiesControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalCitiesApi
     */
    public globalCitiesControllerGet(requestParameters: GlobalCitiesApiGlobalCitiesControllerGetRequest, options?: RawAxiosRequestConfig) {
        return GlobalCitiesApiFp(this.configuration).globalCitiesControllerGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all global cities
     * @param {GlobalCitiesApiGlobalCitiesControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalCitiesApi
     */
    public globalCitiesControllerList(requestParameters: GlobalCitiesApiGlobalCitiesControllerListRequest = {}, options?: RawAxiosRequestConfig) {
        return GlobalCitiesApiFp(this.configuration).globalCitiesControllerList(requestParameters.search, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
}

